import styled from 'styled-components';
import { Box } from 'reflexbox';

export const Separator = styled(Box)`
  background: #E4E4E4;
  width: 100%;
  height: 1px;
`;
